import { ColTypeDef, ValueFormatterParams } from 'ag-grid-community';
import { useSPIntl } from 'hooks/useIntl';
import { useMemo } from 'react';
import { LabelCellRenderer } from 'routes/secondary-market-batch/grid/components/label-cell-renderer';
import { RestrictedDateCellEditor } from 'routes/secondary-market-batch/grid/components/restricted-date-cell-editor';
import { RowData } from 'state/workspaces/secondary-market/batch/model';

export function useRestrictedDateColumnType(): ColTypeDef<RowData, RowData[keyof RowData]> {
  const { formatDisplayedDate } = useSPIntl();

  return useMemo(
    () => ({
      filter: 'agDateColumnFilter',
      filterParams: {
        filterOptions: ['equals', 'notEqual', 'lessThanOrEqual', 'greaterThanOrEqual'],
        inRangeInclusive: true,
      },
      cellClass: 'overflow-visible d-flex align-items-center h-100',
      valueFormatter: ({ value }: ValueFormatterParams<RowData>) => (value ? formatDisplayedDate(value) : ''),
      cellEditor: RestrictedDateCellEditor,
      cellRenderer: LabelCellRenderer,
    }),
    [formatDisplayedDate],
  );
}
